import { Component, OnInit, Pipe, PipeTransform, Input } from '@angular/core';
import { Observable, delay, pipe, map, filter, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AccordionVM } from '../accordion/accordion.model';
import { SmrutiService, SmrutiType } from './smruti.service';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-smruti',
  templateUrl: './smruti.component.html',
  styleUrls: ['./smruti.component.css']
})

export class SmrutiComponent implements OnInit {
  stype: SmrutiType = SmrutiType.smruti;
  smrutis = new BehaviorSubject<AccordionVM[]>([]);
  title: any;
  isProgress = new BehaviorSubject<boolean>(true);

  constructor(private smrutiService: SmrutiService, private route: ActivatedRoute, private router: Router,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.isProgress.next(true)

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const type = this.route.snapshot.paramMap.get('stype')?.toString();
    if (type == "stotra") {
      this.smrutiService.getStotra().subscribe(result => {
        var v = this.smrutis.getValue().concat(result);
        this.smrutis.next(v);
        this.isProgress.next(false);
      });

      this.title = "स्तोत्र";

      this.metaManager.updateMetaTitle("स्तोत्र | Mahanubhav Panth | sarvadhnya.com",
          "Mahanubhav panth stotra, read online, panchkrusha, panchavtar, prarthana, pujavasar",
          "स्तोत्र, stotra, Panchakrushna, Mahanubhav panth, mahanubhav, read online, panchkrusha, panchavtar, prarthana, pujavasar");
    }
    else {
      this.stype = SmrutiType[type as keyof typeof SmrutiType];
      this.smrutiService.getSmruti(this.stype).subscribe(result => {
        var v = this.smrutis.getValue().concat(result);
        this.smrutis.next(v);
        this.isProgress.next(false);
      });
      if (this.stype == SmrutiType.smruti)
      {
        this.title = "स्मृतीस्थळ";
        this.metaManager.updateMetaTitle("स्मृतीस्थळ | Mahanubhav Panth | sarvadhnya.com",
          "Mahanubhav panth smrutisthal (स्मृतीस्थळ), read online, panchkrusha, panchavtar, prarthana, pujavasar",
          "स्मृतीस्थळ, smruti, smrutisthal, smruti sthal, Panchakrushna, Mahanubhav panth, mahanubhav, read online, panchkrusha, panchavtar, prarthana, pujavasar");
      }
      else if (this.stype == SmrutiType.vruddhachar)
      {
        this.title = "वृध्दाचार";
        this.metaManager.updateMetaTitle("वृध्दाचार | Mahanubhav Panth | sarvadhnya.com",
          "Mahanubhav panth vrudhachar (वृध्दाचार), read online, panchkrusha, panchavtar, prarthana, pujavasar",
          "वृध्दाचार, vrudhachar, smrutisthal, smruti sthal, Panchakrushna, Mahanubhav panth, mahanubhav, read online, panchkrusha, panchavtar, prarthana, pujavasar");
      }
      else if (this.stype == SmrutiType.adnyat)
      {
        this.title = "अज्ञात स्मृती";
        this.metaManager.updateMetaTitle("अज्ञात स्मृती | Mahanubhav Panth | sarvadhnya.com",
          "Mahanubhav panth adnyat smruti (अज्ञात स्मृती), read online, panchkrusha, panchavtar, prarthana, pujavasar",
          "अज्ञात स्मृती, adnyat smruti, smruti, smrutisthal, smruti sthal, Panchakrushna, Mahanubhav panth, mahanubhav, read online, panchkrusha, panchavtar, prarthana, pujavasar");
      }
    }
  }
}
